import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  routes: [
    { path: "/", name: "presentation", component: () => import("../views/Presentation/PresentationView.vue") },
    { path: "/events", name: "events", component: () => import("../views/Events/EventsView.vue") },
    { path: "/event/:idSlug", name: "event", component: () => import("../views/Events/EventView.vue") },
    { path: "/city-events/:category?/:city?", name: "events-location", component: () => import("../views/Events/LocationEvent.vue") },
    { path: "/artists", name: "artists", component: () => import("../views/Artists/ArtistsView.vue") },
    { path: "/artist/:idSlug", name: "artist", component: () => import("../views/Artists/ArtistView.vue") },
    { path: "/change-password", name: "change password", component: () => import("../views/Auth/ChangePassword/ChangePassword.vue") },
    { path: "/verify-email", name: "verify-email", component: () => import("../views/Auth/VerifyEmail/VerifyEmail.vue") },
    //{ path: "/pages/landing-pages/about-us", name: "about", component: () => import("../views/LandingPages/AboutUs/AboutView.vue") },
    //{ path: "/pages/landing-pages/contact-us", name: "contactus", component: () => import("../views/LandingPages/ContactUs/ContactView.vue") },
    { path: "/legal-notice", name: "legal-notice", component: () => import("../views/Policies/LegalNotice.vue") },
    { path: "/cookies-policy", name: "cookies-policy", component: () => import("../views/Policies/Cookies.vue") },
    { path: "/privacy-policy", name: "privacy-policy", component: () => import("../views/Policies/PrivacyPolicy.vue") },
    { path: "/about-us", name: "about us", component: () => import("../views/Presentation/AboutUs.vue") },
    { path: "/404", name: "404", component: () => import("../views/404/404.vue") },
    { path: "/faq", name: "faq", component: () => import("../views/LandingPages/faq.vue") },
    //{ path: "/pages/landing-pages/author", name: "author", component: () => import("../views/LandingPages/Author/AuthorView.vue") },
    { path: "/signup", name: "signup", component: () => import("../views/Auth/SignUp/signUp.vue") },
    { path: "/account", name: "account", component: () => import("../views/Profile/account.vue") },
    { path: "/create-event", name: "create-event", component: () => import("../views/Events/NewEvent.vue") },
    { path: "/my-events", name: "my-events", component: () => import("../views/Events/Myevents.vue") },
    { path: "/my-panel", name: "my-panel", component: () => import("../views/Profile/MyPanel.vue") },
    { path: "/my-favorites", name: "my-favorites", component: () => import("../views/Artists/MyFavoritesView.vue") },
    ],
});

router.afterEach(() => {
  if (window.ezstandalone?.cmd) {
    window.ezstandalone.cmd.push(function () {
      window.ezstandalone.showAds();
    });
  }
});

router.beforeEach((to, from, next) => {

  const authStore = useAuthStore();
  const user = authStore.user;
  const rol = authStore.rol;
  const category = authStore.user?.category;
  const contact_name = authStore.user?.contact_name;

  if (user && to.path === '/account') return next();

  if (rol == '1' && (!category || category === null)) {
    return next('/account');
  }

  if (rol == '2' && (!contact_name || contact_name === null)) {
    return next('/account');
  }
  
  next();
});

export default router;
